var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-header header-box header d-flex align-center justify-space-between"},[_c('div',{staticClass:"logo-container gap-12 pt-20 pb-20 pr-32 pl-32",on:{"click":_vm.redirectToLandingPage}},[_c('img',{staticClass:"header-logo",attrs:{"src":_vm.headerLogoGSK,"alt":"GSK"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }